export default "__VITE_PUBLIC_ASSET__c6addfc8__"